import { useEffect, useState } from 'react'
import styles from './styles.module.scss'
import { StatTile, ViewTitle } from '../../reusable'
export interface statsProps {
    dataType: string
    data: any
    dataViewTitle: string
}

export const DataView = (props: statsProps) => {
    const { data, dataType, dataViewTitle } = props
    const [showStats, setShowStats] = useState(false)
    const [showMessage, setShowMessage] = useState('')

    useEffect(() => {
        if (!showStats && data && data.length > 0) {
            setShowStats(true)
        }
    }, [data])

    const getTableBody = () => {
        return (
            <tbody>
                {data.map((elem: any, i: number) => {
                    if (dataType == 'chaseAgentStats') {
                        return (
                            <>
                                <tr key={`${i}-signed`}>
                                    <td className={styles.agentCell}>{elem.agent}</td>
                                    <td className={styles.numberCell}>{elem.signedToday}</td>
                                    <td className={styles.numberCell}>{elem.signedTotal}</td>
                                </tr>
                            </>
                        )
                    }

                    if (dataType == 'pcpReferralAgentStats') {
                        return (
                            <tr key={`${i}-pcp-referral-agent`}>
                                <td className={styles.agentCell}>{elem.agent}</td>
                                <td className={styles.agentCell}>{elem.team_name || 'Unassigned'}</td>
                                <td className={styles.numberCell}>{elem.sentToday}</td>
                                <td className={styles.numberCell}>{elem.sentTotal}</td>
                                <td className={styles.numberCell}>{elem.signedToday}</td>
                                <td className={styles.numberCell}>{elem.signedTotal}</td>
                            </tr>
                        )
                    }

                    if (dataType == 'AgentStats') {
                        return (
                            <>
                                <tr key={`${i}-leads`}>
                                    <td rowSpan={2} className={styles.agentCell}>
                                        {elem.agent}
                                    </td>
                                    <td className={styles.typeCell}>Leads</td>
                                    <td className={styles.numberCell}>{elem.leadsToday}</td>
                                    <td className={styles.numberCell}>{elem.leadsTotal}</td>
                                </tr>
                                <tr key={`${i}-signed`}>
                                    <td className={styles.typeCell}>Signed</td>
                                    <td className={styles.numberCell}>{elem.signedToday}</td>
                                    <td className={styles.numberCell}>{elem.signedTotal}</td>
                                </tr>
                            </>
                        )
                    }
                    if (dataType == 'IntroducerLenderClaimVolume') {
                        return (
                            <tr key={i}>
                                <td>{elem.lender}</td>
                                <td>{elem.count}</td>
                            </tr>
                        )
                    }
                    if (dataType == 'ILClients') {
                        return (
                            <tr key={i}>
                                <td>
                                    {elem.firstName} {elem.lastName}
                                </td>
                                <td>{elem.email}</td>
                                <td>{elem.telephone}</td>
                                <td>{elem.lender}</td>
                                <td>{elem.batchName}</td>
                                <td>
                                    <span
                                        className={`${styles.statusBadge} ${
                                            elem.linkGenerated ? styles.success : styles.warning
                                        }`}
                                    >
                                        {elem.linkGenerated ? 'Generated' : 'Pending'}
                                    </span>
                                </td>
                                <td>{new Date(elem.createdAt).toLocaleDateString()}</td>
                            </tr>
                        )
                    }
                    return (
                        <tr key={i}>
                            <td>{elem.title}</td>
                            {elem.values.map((value: any, i2: number) => {
                                if (
                                    Object.keys(value)[0] === 'Download Link A' ||
                                    Object.keys(value)[0] === 'Download Link B'
                                ) {
                                    return (
                                        <td key={i2}>
                                            <div dangerouslySetInnerHTML={{ __html: `${Object.values(value)[0]}` }} />
                                        </td>
                                    )
                                }
                                if (Object.keys(value)[0] === 'Message') {
                                    return (
                                        <td key={i2}>
                                            <span
                                                data-msgid={`${i}`}
                                                onClick={(e: any) =>
                                                    setShowMessage(`${e.target.getAttribute('data-msgID')}`)
                                                }
                                            >
                                                Click here to view
                                                <div className={`${showMessage === `${i}` ? styles.display : ''} `}>
                                                    <div
                                                        dangerouslySetInnerHTML={{
                                                            __html: `${Object.values(value)[0]}`,
                                                        }}
                                                    />
                                                </div>
                                            </span>
                                        </td>
                                    )
                                }
                                return <td key={i2}>{`${Object.values(value)[0]}`}</td>
                            })}
                        </tr>
                    )
                })}
            </tbody>
        )
    }

    return (
        <div className={styles.dataView}>
            <h3>{dataViewTitle}</h3>
            <div className={styles.dataTableContainer}>
                <table className={dataType === 'AgentStats' ? styles.agentStatsTable : ''}>
                    {showStats ? (
                        <>
                            {getTableHeaders(dataType)}
                            {getTableBody()}
                        </>
                    ) : (
                        <></>
                    )}
                </table>
            </div>
        </div>
    )
}

const getTableHeaders = (type: string) => {
    switch (type) {
        case 'chaseAgentStats':
            return (
                <thead>
                    <tr>
                        <th>Agent</th>
                        <th>Signed Today</th>
                        <th>Signed Total</th>
                    </tr>
                </thead>
            )
            break
        case 'pcpReferralAgentStats':
            return (
                <thead>
                    <tr>
                        <th>Agent</th>
                        <th>Team</th>
                        <th>Sent Today</th>
                        <th>Sent Total</th>
                        <th>Signed Today</th>
                        <th>Signed Total</th>
                    </tr>
                </thead>
            )
            break
        case 'AgentStats':
            return (
                <thead>
                    <tr>
                        <th>Agent</th>
                        <th>Type</th>
                        <th>Today</th>
                        <th>Total</th>
                    </tr>
                </thead>
            )
            break
        case 'IntroducerLenderClaimVolume':
            return (
                <thead>
                    <tr>
                        <th>Lender</th>
                        <th>Total Cases</th>
                    </tr>
                </thead>
            )
            break
        case 'ILClients':
            return (
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Phone</th>
                        <th>Lender</th>
                        <th>Batch</th>
                        <th>Link Status</th>
                        <th>Created</th>
                    </tr>
                </thead>
            )
            break
        case 'FOA':
            return (
                <thead>
                    <tr>
                        <th>Lender</th>
                        <th>Active Cases</th>
                        <th>Sent</th>
                        <th>Not Signed</th>
                        <th>Partial</th>
                        <th>Complete</th>
                    </tr>
                </thead>
            )
            break
        case 'FOA-RESPONSE':
            return (
                <thead>
                    <tr>
                        <th>Lender</th>
                        <th>Active Cases</th>
                        <th>Sent</th>
                        <th>Outstanding</th>
                        <th>Ready to Send</th>
                    </tr>
                </thead>
            )
            break

        case 'FOA Chase':
            return (
                <thead>
                    <tr>
                        <th>Chase Date</th>
                        <th>Total Sent</th>
                        <th>Communication Type</th>
                        <th>Communication Group ID</th>
                        <th>Message</th>
                    </tr>
                </thead>
            )
            break

        case 'POC Chase':
            return (
                <thead>
                    <tr>
                        <th>Chase Date</th>
                        <th>Total Sent</th>
                        <th>Communication Type</th>
                        <th>Communication Group ID</th>
                        <th>Message</th>
                    </tr>
                </thead>
            )
            break

        case 'POC Issued':
            return (
                <thead>
                    <tr>
                        <th>POC Batch ID</th>
                        <th>Total Cases</th>
                        <th>Sent Date </th>
                        <th>Batch Document A</th>
                        <th>Batch Document B</th>
                    </tr>
                </thead>
            )
            break

        default:
            break
    }
}
